import * as yup from 'yup';
import { IMAGE_PDF_SUPPORTED_FORMATS, TWO_MB } from '@src/constants';
import { phoneSchemaFactory } from '@src/validations';
import { BeneficialOwnerValues } from '../components/beneficialOwnerStep';
import Api from '@sendsprint/api-types';

export const getBeneficialOwnerSchema = (index: number, values: BeneficialOwnerValues) =>
  yup.object().shape({
    role: yup
      .string()
      .required('Please select role')
      .test('FIRST_OWNER', 'This selection must be an owner', (value) => {
        if (value && value !== 'Owner' && index === 0) {
          return false;
        }
        return true;
      }),
    shareSize: yup
      .string()
      .required('Please enter percentage')
      // .test('OWNER_PERCENTAGE', 'The minimum percentage of the owner must be 25%', (value) => {
      //   if (value && index === 0 && Number(value) < 25) {
      //     return false;
      //   }
      //   return true;
      // })
      .test('LOWEST_PERCENTAGES', 'The minimum percentage of the owner must be 1%', (value) => {
        if (value && Number(value) < 1) {
          return false;
        }
        return true;
      })
      .test('HIGHEST_PERCENTAGES', 'The maximum percentage of the owner must be 100%', (value) => {
        if (value && Number(value) > 100) {
          return false;
        }
        return true;
      }),
    legalFirstName: yup.string().required('Please enter first name'),
    legalLastName: yup.string().required('Please enter last name'),
    dateOfBirth: yup
      .string()
      .required('Date is required')
      // .matches(/^\d{4}-\d{2}-\d{2}$/, 'Date must be in YYYY-MM-DD format')
      .test('MAXIMUM_OF_TODAY', 'The maximum date to be selected is yesterday', (value) => {
        const inputDate = new Date(value || '');
        const today = new Date();
        today.setHours(0, 0, 0, 0); // remove time
        return inputDate < today;
      }),
    gender: yup.string().required('Please select gender'),
    email: yup.string().email('Please enter valid email').required('Please enter email'),
    citizenship: yup.string().required('Please select citizenship'),
    country: yup.string().required('Please select country'),
    stateOfResidence: yup.string().required('Please select state'),
    address: yup.string().required('Please enter address'),
    city: yup.string().required('Please enter city'),
    zipCode: yup.string().required('Please enter zip code'),
    socialSecurityNumber:
      values.citizenship === Api.Model.CountryInitials.UnitedStates ||
      values.country === Api.Model.CountryInitials.UnitedStates
        ? yup
            .string()
            .matches(/^\d+$/, 'Please enter only digits')
            .length(4, 'Please enter last 4 SSN digits')
            .required('Please enter last 4 SSN digits')
        : yup.string(),
    homePhoneNumber: phoneSchemaFactory({
      countryCodeOrPath:
        values?.country === Api.Model.CountryInitials.NigeriaNig
          ? Api.Model.CountryInitials.Nigeria
          : values?.country || '',
      required: true,
      numbersOnly: true
    }),
    formId: yup.string().required('Please select id'),
    idNumber: yup.string().required('Please select id number'),
    agencyApplicationForm: yup
      .mixed()
      .nullable()
      .required('Please add document')
      .test(
        'FILE_FORMAT',
        'Please check the format of the files selected. The supported formats are jpeg, jpg or png.',
        (value) => {
          if (typeof value === 'string') {
            return true;
          }

          if (value) {
            if (!IMAGE_PDF_SUPPORTED_FORMATS.includes(value?.type)) {
              return false;
            }
          }

          return true;
        }
      )
      .test('FILE_SIZE', 'File too big. Maximum of 2mb', (value) => {
        if (typeof value === 'string') {
          return true;
        }

        if (value) {
          if (value.size > TWO_MB) {
            return false;
          }
        }

        return true;
      }),
    driverLicense:
      values.formId?.toString() === '3'
        ? yup
            .mixed()
            .nullable()
            .required('Please add document')
            .test(
              'FILE_FORMAT',
              'Please check the format of the files selected. The supported formats are jpeg, jpg or png.',
              (value) => {
                if (typeof value === 'string') {
                  return true;
                }

                if (value) {
                  if (!IMAGE_PDF_SUPPORTED_FORMATS.includes(value?.type)) {
                    return false;
                  }
                }

                return true;
              }
            )
            .test('FILE_SIZE', 'File too big. Maximum of 2mb', (value) => {
              if (typeof value === 'string') {
                return true;
              }

              if (value) {
                if (value.size > TWO_MB) {
                  return false;
                }
              }

              return true;
            })
        : yup.mixed().nullable()
  });
